module.exports = __webpack_public_path__ + "static/media/icon_logout.dab1dbdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_logout.svg
// module id = 332
// module chunks = 0